var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoAuto = function SvgNoAuto(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.91406,
    y: 7.5,
    width: 14.5681,
    height: 1.35858,
    transform: "rotate(42.284 6.91406 7.5)",
    fill: "#8B90A0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1719 11.3521L10.4258 13.77H12.5674L12.0723 12.1714L15.4844 15.2739L16.3008 17.4819H13.7168L13.1416 15.6226H9.85449L9.28027 17.4819H6.70312L9.50977 9.84131L11.1719 11.3521ZM12.623 7.52881L14.5791 12.8228L9.95898 8.62061L10.3604 7.52881H12.623Z",
    fill: "#8B90A0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoAuto);
export { ForwardRef as ReactComponent };